// src/app/meter/components/meter-analytics/meter-consumption-trend/meter-consumption-trend.component.ts

import { Component, Input, OnChanges } from '@angular/core';
import { ChartConfiguration } from 'chart.js';
import { TranslateService } from '@ngx-translate/core';
import { MeterTrendSeries } from '../../../models/meter-analytics.model';

@Component({
    selector: 'app-meter-consumption-trend',
    templateUrl: './meter-consumption-trend.component.html',
    styleUrls: ['./meter-consumption-trend.component.scss'],
})
export class MeterConsumptionTrendComponent implements OnChanges {
    @Input() data: MeterTrendSeries | null = null;
    @Input() comparePrevious = false;

    chartData: ChartConfiguration<'line'>['data'] = { labels: [], datasets: [] };

    chartOptions: ChartConfiguration<'line'>['options'] = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { position: 'bottom', labels: { boxWidth: 12, padding: 16 } },
        },
        scales: {
            x: { grid: { display: false } },
            y: { beginAtZero: true },
        },
        elements: {
            point: { radius: 3, hoverRadius: 5 },
            line: { tension: 0.3 },
        },
    };

    constructor(private translate: TranslateService) {}

    ngOnChanges(): void {
        if (!this.data || this.data.current.length === 0) return;

        const labels = this.data.current.map((p) => this.formatDate(p.date));
        const datasets: ChartConfiguration<'line'>['data']['datasets'] = [
            {
                label: this.translate.instant('meter.analytics.current_period'),
                data: this.data.current.map((p) => p.value),
                borderColor: '#1976d2',
                backgroundColor: '#1976d220',
                pointBackgroundColor: '#1976d2',
                pointBorderColor: '#1976d2',
                fill: true,
            },
        ];

        if (this.comparePrevious && this.data.previous && this.data.previous.length > 0) {
            datasets.push({
                label: this.translate.instant('meter.analytics.previous_period'),
                data: this.data.previous.map((p) => p.value),
                borderColor: '#d1d5db',
                backgroundColor: 'transparent',
                pointBackgroundColor: '#d1d5db',
                pointBorderColor: '#d1d5db',
                borderDash: [5, 5],
                fill: false,
            });
        }

        this.chartData = { labels, datasets };
    }

    private formatDate(dateStr: string): string {
        if (dateStr.includes('W')) {
            return dateStr;
        }
        const date = new Date(dateStr + 'T00:00:00');
        return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
    }
}
